/* Copyright (C) 2019 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */

// 1. React and fabric. 
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom'                    ;
// 2. Store and Types. 
import DETAILVIEWS_RELATIONSHIP            from '../../types/DETAILVIEWS_RELATIONSHIP';
// 3. Scripts. 
// 4. Components and Views. 
import SubPanelView                        from '../../views/SubPanelView'            ;

interface IUsersLoginsProps extends RouteComponentProps<any>
{
	PARENT_TYPE      : string;
	row              : any;
	layout           : DETAILVIEWS_RELATIONSHIP;
}

class UsersLogins extends React.Component<IUsersLoginsProps>
{
	constructor(props: IUsersLoginsProps)
	{
		super(props);
		//console.log((new Date()).toISOString() + ' ' + this.constructor.name + '.constructor ' + props.PARENT_TYPE, props.layout);
	}

	public render()
	{
		return <SubPanelView { ...this.props } disableView={ true } disableEdit={ true } disableRemove={ true } CONTROL_VIEW_NAME='Users.Logins' />;
	}
}

export default withRouter(UsersLogins);
